import { render, staticRenderFns } from "./cards-control.vue?vue&type=template&id=3a052b14&"
import script from "./cards-control.vue?vue&type=script&lang=js&"
export * from "./cards-control.vue?vue&type=script&lang=js&"
import style0 from "./cards-control.vue?vue&type=style&index=0&id=3a052b14&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports